module.exports = __webpack_public_path__ + "static/img/banner02.a9c5725.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/Normal04/banner02.png
// module id = lro1
// module chunks = 1